import { render } from "./TableroNegocio.vue?vue&type=template&id=6f58279f"
import script from "./TableroNegocio.vue?vue&type=script&lang=js"
export * from "./TableroNegocio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__